export const findElement = (element, selector) => {
  return element.shadowRoot !== null
    ? element.shadowRoot.querySelector(selector)
    : element.querySelector(selector);
};
